export const getImgUrl = (pic: string) => {
  return require('../assets/' + pic);
};
